var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7775 3.5C22.8089 3.5 23.798 3.9141 24.5273 4.65121C25.2566 5.38832 25.6663 6.38805 25.6663 7.43048V17.9118C25.6663 18.9542 25.2566 19.9539 24.5273 20.691C23.798 21.4281 22.8089 21.8422 21.7775 21.8422H15.296L8.81449 25.7727V21.8422H6.2219C5.1905 21.8422 4.20135 21.4281 3.47204 20.691C2.74273 19.9539 2.33301 18.9542 2.33301 17.9118V7.43048C2.33301 6.38805 2.74273 5.38832 3.47204 4.65121C4.20135 3.9141 5.1905 3.5 6.2219 3.5H21.7775Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 10.7729C11.375 10.2508 11.6168 9.75005 12.0473 9.38083C12.4778 9.01162 13.0617 8.8042 13.6705 8.8042H14.3263C14.9352 8.8042 15.519 9.01162 15.9495 9.38083C16.38 9.75005 16.6218 10.2508 16.6218 10.7729C16.646 11.199 16.5311 11.6214 16.2945 11.9765C16.058 12.3316 15.7125 12.6001 15.3101 12.7417C14.9078 12.9305 14.5623 13.2885 14.3257 13.762C14.0891 14.2354 13.9743 14.7986 13.9984 15.3667",
    stroke: "currentColor",
    strokeWidth: 1.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.001 17.4941V17.5016",
    stroke: "currentColor",
    strokeWidth: 1.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpTabIcon);
export default __webpack_public_path__ + "static/media/help-tab-icon.5152cd3696c4a802f9a5a03552183f1d.svg";
export { ForwardRef as ReactComponent };